"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.labelId = exports.inputId = exports.errorId = void 0;
var withPrefix = function withPrefix(prefix) {
  return function (name, fieldId) {
    return name ? "".concat(prefix).concat(fieldId, "__").concat(name === null || name === void 0 ? void 0 : name.replace(/\[(.*?)\]/g, '_$1')) : "".concat(prefix).concat(fieldId);
  };
};
var inputId = exports.inputId = withPrefix('form_group_input');
var errorId = exports.errorId = withPrefix('form_group_error');
var labelId = exports.labelId = withPrefix('form_group_label');